import { Box } from '@mui/material';
import { useCallback, FC } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { YouCanComeBackNote } from '../../../../general/components/footers/you-can-come-back-note';
import { WizardPage } from '../../../../general/components/wizard-page';
import { BUSINESS_INFO_TWO } from '../../../../paths';
import { RootState } from '../../../../store';
import { SpendIntentForm } from '../../components/spend-intent-form';

const selector = ({ nextStep: { error } }: RootState) => ({
  error,
});

const SpendIntentPage: FC = () => {
  const navigate = useNavigate();
  const { error } = useSelector(selector);
  const handleBack = useCallback(() => {
    navigate(BUSINESS_INFO_TWO);
  }, [navigate]);

  return (
    <WizardPage
      title={
        <Box display="flex" justifyContent="center">
          <Box maxWidth="sm">Besides fuel, what else do you plan to purchase with Coast?</Box>
        </Box>
      }
      subtext={
        <Box display="flex" justifyContent="center">
          <Box maxWidth="sm">
            You can also use Coast cards for other types of business spend, with 1% cashback. You can set separate
            controls and limits on each category. Don’t worry, you can change your selection later &#8212; telling us
            now will help us enable these features for you right away.
          </Box>
        </Box>
      }
      footer={<YouCanComeBackNote />}
      onBack={handleBack}
      error={error}
      formWidth="sm"
    >
      <SpendIntentForm />
    </WizardPage>
  );
};

export { SpendIntentPage };
